import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { localeToUpperCase } from '../../../utils';
import { trustpilotBusinessUnitIds, trustpilotTemplateIds } from '../utils/trustpilot.config';
import { RatingSummary } from './Reviews.styles';

export function ReviewsMini({ productId }: { productId: string }) {
  const { locale } = useRouter();
  const templateId = trustpilotTemplateIds.productMiniMultiSource;
  const { buid } = trustpilotBusinessUnitIds;
  const widgetRef = useRef(null);

  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(widgetRef.current, true);
    }
  }, [productId]);

  return (
    <RatingSummary>
      <div
        ref={widgetRef}
        className="trustpilot-widget"
        data-locale={localeToUpperCase(locale as string)}
        data-template-id={templateId}
        data-businessunit-id={buid}
        data-style-height="24px"
        data-style-width="100%"
        data-sku={productId}
        data-no-reviews="collapse"
        data-scroll-to-list="true"
        data-style-alignment="left"
      />
    </RatingSummary>
  );
}

export default ReviewsMini;
